module.exports = __webpack_public_path__ + "static/avatar_gg-5551136af740cc9d189e9637a7760824.png";